import classNames from "classnames";
import React from "react";
import { formatCompletionRatio } from "../../../formatUtils";
import { STRINGS } from "../../../strings";
import { TrainingCenterCaregiverBundle } from "../../../system/AppState/AppStateTrainingCenter";
import { translate } from "../../../translate";
import { formatDuration } from "../../../utils/dateUtils";
import { CHECK_SVG } from "../../../utils/svgs";
import { PLAY_ICON_ALT } from "../../../utils/svgs_new";
import { AppIcon } from "../../Generic/AppIcon";
import AsyncImage from "../../Generic/AsyncImage";
import { If } from "../../Generic/If";
import { IsDefined } from "../../Generic/IsDefined";
import { TrainingCenterLanguagePreference } from "../../TrainingCenter/TrainingCenterLanguageLookup";
import {
  getDisplayData,
  getTrainingCenterBundleCompletionRatio,
  getTraningCenterBundleDuration,
  isTrainingCenterBundleCompleted,
  lookupBundleThumbnailUrl,
} from "../../TrainingCenter/TrainingCenterUtils";

interface Props {
  bundle: TrainingCenterCaregiverBundle;
  languagePreference: TrainingCenterLanguagePreference;
  className?: string;
  showOnboardingMessage: boolean;
  onClickPlayBundle: () => void;
  onClick?: () => void;
}

const TrainingCenterBundleHeader = (props: Props) => {
  const isCompleted = isTrainingCenterBundleCompleted(props.bundle);
  const duration = getTraningCenterBundleDuration(props.bundle.bundleItems);
  const completionRatio = getTrainingCenterBundleCompletionRatio(props.bundle.bundleItems);
  const displayData = props.showOnboardingMessage
    ? translate(STRINGS.COMPLETE_YOUR_ONBOARDING_ANYTIME)
    : getDisplayData(props.bundle.bundleDisplayData, props.languagePreference).data.title;
  const thumbnailUrl = lookupBundleThumbnailUrl(props.languagePreference, props.bundle);

  return (
    <div
      className={classNames("TrainingCenterBundleHeader", props.className)}
      onClick={props.onClick}
    >
      <div className="meta">
        {props.bundle.showDuration ? (
          <div className="meta-bundle-duration">{formatDuration(duration)}</div>
        ) : null}
        <div className="meta-bundle-completion">{formatCompletionRatio(completionRatio)}</div>
      </div>

      <h1 className="title">{displayData}</h1>

      <If condition={isCompleted}>
        <div className="bundle-icon bundle-completed-icon">
          <AppIcon icon={CHECK_SVG} />
        </div>
      </If>

      <If condition={!isCompleted}>
        <div className="bundle-icon bundle-play-icon" onClick={props.onClickPlayBundle}>
          <AppIcon icon={PLAY_ICON_ALT} size={16} />
        </div>
      </If>

      <IsDefined value={thumbnailUrl}>
        {(value) => <AsyncImage className="bundle-thumbnail" src={value} />}
      </IsDefined>
    </div>
  );
};

export default TrainingCenterBundleHeader;
